/**
 * Prüfungsmodus — pure Logik (Ziehung + Scoring), View in components/Exam.
 *
 * 85-%-Schwelle = Mock-Klausur-Regel aus CLAUDE.md/MASTERPLAN: unter 85 %
 * wird das Thema in derselben Woche wiederholt.
 */
import type { Card } from '$types/card';

export const EXAM_PASS_THRESHOLD = 0.85;

/** Fisher-Yates, rng injizierbar für deterministische Tests. */
export function shuffle<T>(arr: readonly T[], rng: () => number = Math.random): T[] {
  const out = [...arr];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const tmp = out[i] as T;
    out[i] = out[j] as T;
    out[j] = tmp;
  }
  return out;
}

/**
 * Zieht `count` Karten für eine Probe-Klausur. Vokabeln sind ausgenommen —
 * Pre-Training-Karten sind kein Klausur-Niveau.
 */
export function drawExamCards(
  pool: readonly Card[],
  count: number,
  rng: () => number = Math.random,
): Card[] {
  const eligible = pool.filter((c) => c.type !== 'vocab');
  return shuffle(eligible, rng).slice(0, count);
}

export interface ExamResult {
  total: number;
  correct: number;
  pct: number;
  passed: boolean;
}

export function scoreExam(marks: readonly boolean[]): ExamResult {
  const total = marks.length;
  const correct = marks.filter(Boolean).length;
  const pct = total > 0 ? correct / total : 0;
  return { total, correct, pct, passed: total > 0 && pct >= EXAM_PASS_THRESHOLD };
}
